<div *ngIf="isLoading" id="loading-overlay">
    <div class="spinner">
      <div class="spinner">
        <p>Loading CRMT</p>
      </div>
      <ix-spinner size="large"></ix-spinner>
    </div>
  </div>
  <ix-basic-navigation applicationName="Cab Radio Remote Management Terminal">
    <svg width="104" height="18" slot="logo" viewBox="0 0 130 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path
          d="M7.97057188,1.42108547e-14 C9.27087664,1.42108547e-14 11.1527228,0.250443857 13.614223,0.751924104 L13.614223,4.67231852 C11.7827733,3.90676616 10.0826941,3.52478002 8.51190938,3.52478002 C6.30012665,3.52478002 5.19423528,4.16037019 5.19423528,5.43411817 C5.19423528,5.91031702 5.41715006,6.2986235 5.86316838,6.59963016 C6.23406384,6.84335864 7.25633857,7.35787461 8.9275388,8.14515317 C11.3337349,9.26346004 12.9356636,10.2356088 13.733891,11.0623896 C14.6810429,12.0432288 15.1553739,13.3122366 15.1553739,14.8676351 C15.1553739,17.1036563 14.2261533,18.8091632 12.368656,19.9843532 C10.863934,20.9371459 8.91262748,21.4117647 6.5158689,21.4117647 C4.49208203,21.4117647 2.4528176,21.1625059 0.399585599,20.6610257 L0.399585599,16.5855852 C2.61627585,17.3155856 4.57777493,17.6807833 6.28408282,17.6807833 C8.64007122,17.6807833 9.81806542,17.0291947 9.81806542,15.7268077 C9.81806542,15.2413258 9.64667963,14.8334657 9.30296429,14.5030299 C8.95151016,14.1524481 8.051546,13.6667687 6.60495931,13.0444117 C4.00982355,11.9278825 2.31748322,10.9754848 1.53039208,10.1880087 C0.51000486,9.14811366 6.39488462e-14,7.83703612 6.39488462e-14,6.25260345 C6.39488462e-14,4.21231557 0.743300939,2.65711452 2.22877031,1.5885804 C3.69781836,0.529131777 5.61080846,1.42108547e-14 7.97057188,1.42108547e-14 Z M122.307282,1.42108547e-14 C123.633823,1.42108547e-14 125.353343,0.220422196 127.462068,0.663439208 L127.949234,0.751924104 L127.949234,4.67231852 C126.117407,3.90676616 124.412231,3.52478002 122.83333,3.52478002 C120.629664,3.52478002 119.530756,4.16037019 119.530756,5.43411817 C119.530756,5.91031702 119.752539,6.2986235 120.197236,6.59963016 C120.550955,6.83407563 121.577193,7.34878911 123.276329,8.14515317 C125.664593,9.26346004 127.263125,10.2356088 128.068147,11.0623896 C129.016809,12.0432288 129.490196,13.3122366 129.490196,14.8676351 C129.490196,17.1036563 128.566072,18.8091632 126.718012,19.9843532 C125.204419,20.9371459 123.248205,21.4117647 120.852012,21.4117647 C118.82596,21.4117647 116.785941,21.1625059 114.734408,20.6610257 L114.734408,16.5855852 C116.932412,17.3155856 118.893533,17.6807833 120.620038,17.6807833 C122.975837,17.6807833 124.152699,17.0291947 124.152699,15.7268077 C124.152699,15.2413258 123.985843,14.8334657 123.653453,14.5030299 C123.3003,14.1524481 122.396561,13.6667687 120.941292,13.0444117 C118.353895,11.9371655 116.659855,10.9851628 115.865214,10.1880087 C114.845582,9.15739668 114.336521,7.84138136 114.336521,6.23858018 C114.336521,4.20718028 115.077746,2.65711452 116.564914,1.5885804 C118.031886,0.529131777 119.946952,1.42108547e-14 122.307282,1.42108547e-14 Z M53.9199712,0.358660095 L58.8818542,13.5442922 L63.9681239,0.358660095 L70.7520191,0.358660095 L70.7520191,20.9947994 L65.5290937,20.9947994 L65.5290937,6.38392847 L59.7457669,21.2043585 L56.3310749,21.2043585 L50.6589224,6.38392847 L50.6589224,20.9947994 L46.7778269,20.9947994 L46.7778269,0.358660095 L53.9199712,0.358660095 Z M23.7747202,0.35858109 L23.7747202,20.9947204 L18.2662148,20.9947204 L18.2662148,0.35858109 L23.7747202,0.35858109 Z M42.9545836,0.358660095 L42.9545836,4.09122162 L34.1355766,4.09122162 L34.1355766,8.75089943 L41.8120746,8.75089943 L41.8120746,12.1553953 L34.1355766,12.1553953 L34.1355766,17.0526788 L43.1818397,17.0526788 L43.1818397,20.9947994 L28.8265807,20.9947994 L28.8265807,0.358660095 L42.9545836,0.358660095 Z M89.9327318,0.358660095 L89.9327318,4.09122162 L81.1144798,4.09122162 L81.1144798,8.75089943 L88.790789,8.75089943 L88.790789,12.1553953 L81.1144798,12.1553953 L81.1144798,17.0526788 L90.1614979,17.0526788 L90.1614979,20.9947994 L75.8049177,20.9947994 L75.8049177,0.358660095 L89.9327318,0.358660095 Z M100.170315,0.358660095 L106.94364,14.1729694 L106.94364,0.358660095 L110.823792,0.358660095 L110.823792,20.9947994 L104.620683,20.9947994 L97.6674784,6.99463226 L97.6674784,20.9947994 L93.7860054,20.9947994 L93.7860054,0.358660095 L100.170315,0.358660095 Z"
          id="path-1"></path>
      </defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <mask id="mask-2" fill="currentColor">
          <use xlink:href="#path-1"></use>
        </mask>
        <use id="Siemens" fill="#171717" xlink:href="#path-1"></use>
        <g id="c/white" mask="url(#mask-2)" fill="#FFFFFF">
          <rect id="Rectangle" x="0" y="0" width="130" height="22"></rect>
        </g>
      </g>
    </svg>
    <ix-menu *ngIf="!isLoading" enableToggleTheme=true>
      <ix-menu-avatar 
          image="https://ui-avatars.com/api/?name={{name$ | async}}"
          (logoutClick)="handleSignOut()">
          <ix-menu-avatar-item 
            label="Profile"
            routerLink="./profile">
          </ix-menu-avatar-item>
      </ix-menu-avatar>
      <ix-menu-item  
          home=true
          tabIcon="tree"
          routerLink="fleet-management"
          routerLinkActive="active">
          Fleet Management
        </ix-menu-item>
  
        <ix-menu-item  
          tabIcon="list"
          routerLink="fleet-list"
          routerLinkActive="active">
          Fleet List
        </ix-menu-item>
  
        <ix-menu-item 
          [disabled]="disableStandard"
          routerLink="upload-file"
          routerLinkActive="active"
          tabIcon="cloud-upload">
          Upload File
        </ix-menu-item>
  
        <ix-menu-item 
          [disabled]="disableStandard"
          routerLink="deploy-file"
          routerLinkActive="active"
          tabIcon="cloud-download">
          Deploy File
        </ix-menu-item>
  
        <!-- Disabled 'Device Config' tab as part of EPCOL-315 -->
        <!-- <ix-menu-item 
          [disabled]="disableStandard"
          routerLink="device-config"
          routerLinkActive="active"
          tabIcon="configuration">
          Device Config
        </ix-menu-item> -->
  
        <ix-menu-item 
          [disabled]="disableStandard"
          routerLink="send-command"
          routerLinkActive="active"
          tabIcon="goto">
          Send Command
        </ix-menu-item>
  
        <ix-menu-item 
          routerLink="job-list"
          routerLinkActive="active"
          tabIcon="tasks-all">
          Jobs List
        </ix-menu-item>
  
        <ix-menu-item 
          routerLink="file-editor"
          routerLinkActive="active"
          tabIcon="pen">
          File Viewer / Editor
        </ix-menu-item>
  
        <ix-menu-item 
          [disabled]="disableSuper"
          routerLink="audit-log"
          routerLinkActive="active"
          tabIcon="book">
          Audit Log
        </ix-menu-item>
  
        <ix-menu-item 
          [disabled]="disableStandard"
          routerLink="device-registration"
          routerLinkActive="active"
          tabIcon="project-new">
          Register Device
        </ix-menu-item>    
  
        <ix-menu-about>
          <ix-menu-about-item label="Application Information">
            <ix-layout-grid>
              <ix-row class="content-row">
                <ix-col class="content-data" size="5"><ix-typography class="content-label" format="display">Application
                    Name</ix-typography></ix-col>
                <ix-col class="content-data" size="7"><ix-typography
                    format="display">{{applicationName}}</ix-typography></ix-col>
              </ix-row>
        
              <ix-row class="content-row">
                <ix-col class="content-data" size="5"><ix-typography class="content-label" format="display">Application
                    Version</ix-typography></ix-col>
                <ix-col class="content-data" size="5"><ix-typography
                    format="display">{{applicationVersion}}</ix-typography></ix-col>
              </ix-row>
            </ix-layout-grid>
          </ix-menu-about-item>
        </ix-menu-about>
  
    </ix-menu>   
    <router-outlet></router-outlet>
</ix-basic-navigation>
